<div class="setting-panel">
  <strong i18n class="text-muted title">Project Alignment</strong>
  <table class="table mt-3">
    <thead class="text-muted">
      <tr>
        <th i18n>File name</th>
        <th i18n>Upload date</th>
        <th i18n class="text-right">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="kml">
        <td>{{ kml.name }}</td>
        <td></td>
        <td class="text-right">
          <button
            type="button"
            class="btn btn-sm btn-secondary sm-text-default-red"
            (click)="removeKML()"
            title="Delete"
            i18n-title="Delete"
            [disabled]="readonly"
          >
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <label class="default-label btn btn-primary" [class.disabled]="readonly">
    <span i18n>Upload alignment</span>
    <input
      type="file"
      name="file"
      class="d-none"
      (change)="upload($event)"
      accept=".kml"
      [disabled]="readonly"
    />
  </label>
  <div class="d-inline-block" *ngIf="uploading">
    <span class="loading-spinner">
      <i class="cc-icon cc-icon-spinner-fw"></i>
    </span>
    <span i18n>Uploading</span>
  </div>
</div>
